import { render, staticRenderFns } from "./CodeChip.vue?vue&type=template&id=f6dcc76a"
import script from "./CodeChip.vue?vue&type=script&setup=true&lang=ts"
export * from "./CodeChip.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CodeChip.vue?vue&type=style&index=0&id=f6dcc76a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports